import React, { useEffect, useState } from 'react';
import usePersistedFilters from '../../hooks/usePersistedFilters';
import { MdOutlineHealthAndSafety } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetPriceListSubTypesQuery } from '../../redux/api/modules/managementApi';
import CheckPermission from '../../hooks/CheckPermission';
import PriceItemsSubTypeTable from '../../components/his/price-list/PriceItemsSubTypeTable';
import CreatePriceSubTypeForm from '../../components/his/price-list/CreatePriceSubTypeForm';
const ReusableModal = React.lazy(() => import('../../shared/ReuseableModal'));

const PriceListSubTypes = () => {
  const navigate = useNavigate();
  const { hasPermission } = CheckPermission();
  const [selectedItemData, setSelectedItemData] = useState(null);
  const { t, i18n } = useTranslation();
  const [openCreatePriceTypeModal, setOpenCreatePriceTypeModal] = useState(false);
  const { filters: payloadData, setFilters: setPayloadData } = usePersistedFilters(
    'price_list_subtypes',
    { page: 1, per_page: 20, is_show_all: true }
  );

  const {
    data,
    isLoading: queryLoading,
    isFetching: queryFetching,
    refetch
  } = useGetPriceListSubTypesQuery(payloadData);

  const loading = queryLoading || queryFetching;

  return (
    <div className='w-full h-full'>
      <PriceItemsSubTypeTable
        refetch={refetch}
        itemsData={data}
          payloadData={payloadData}
          loading={loading}
          selectedItemData={selectedItemData}
          setSelectedItemData={setSelectedItemData}
          setOpenCreatePriceTypeModal={setOpenCreatePriceTypeModal}
          setPayloadData={setPayloadData}
        />
      <ReusableModal
        isVisible={openCreatePriceTypeModal}
        position='top'
        title={selectedItemData ? t('update_price_list_sub_type') : t('create_new_price_list_sub_type')}
        HeaderIcon={MdOutlineHealthAndSafety}
        onClose={() => {
          setOpenCreatePriceTypeModal(false);
          setSelectedItemData(null);
        }}
      >
        <CreatePriceSubTypeForm
          selectedItemData={selectedItemData}
          setSelectedItemData={setSelectedItemData}
          getPriceTypePayload={payloadData}
          refetch={refetch}
          setOpenCreatePriceTypeModal={setOpenCreatePriceTypeModal}
        />
      </ReusableModal>
    </div>
  );
};

export default PriceListSubTypes;
